import Box from '@mui/material/Box';
import Skeleton from '@mui/material/Skeleton';
import { FC } from 'react';

/** Mirrors the queue rows: avatar, two text lines, the date on the right. */
export const TeacherReviewPageSkeleton: FC = () => (
  <Box>
    {Array.from({ length: 5 }).map((_, i) => (
      // oxlint-disable-next-line react/no-array-index-key
      <Box key={i} sx={{ display: 'flex', alignItems: 'center', gap: 2, px: 2.5, py: 1.75 }}>
        <Skeleton variant="circular" width={40} height={40} />
        <Box sx={{ flex: 1 }}>
          <Skeleton variant="text" width="30%" />
          <Skeleton variant="text" width="50%" />
        </Box>
        <Skeleton variant="text" width={110} />
      </Box>
    ))}
  </Box>
);
